'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { isBoolean } from 'underscore';
import { FINDER_ASSET_TOGGLE_RENAME, FINDER_FILE_RENAME_CONFIRM_HIDE, FINDER_FOLDER_RENAME_CONFIRM_HIDE, FINDER_OPTIONS_FETCH } from 'DesignData/actions/ActionTypes';

function showRenameFileConfirm(state = true, action) {
  switch (action.type) {
    case FINDER_OPTIONS_FETCH:
      {
        const {
          options
        } = action;
        if (!options) return state;

        if (isBoolean(options.showRenameFileConfirm)) {
          return options.showRenameFileConfirm;
        }

        return state;
      }

    case FINDER_FILE_RENAME_CONFIRM_HIDE:
      {
        return false;
      }

    default:
      {
        return state;
      }
  }
}

function showRenameFolderConfirm(state = true, action) {
  switch (action.type) {
    case FINDER_OPTIONS_FETCH:
      {
        const {
          options
        } = action;
        if (!options) return state;

        if (isBoolean(options.showRenameFolderConfirm)) {
          return options.showRenameFolderConfirm;
        }

        return state;
      }

    case FINDER_FOLDER_RENAME_CONFIRM_HIDE:
      {
        return false;
      }

    default:
      {
        return state;
      }
  }
}

function currentRenameAsset(state = SeamlessImmutable({
  assetId: null,
  isDuplicate: false
}), action) {
  switch (action.type) {
    case FINDER_ASSET_TOGGLE_RENAME:
      {
        const {
          assetId,
          isDuplicate = false
        } = action;
        return state.merge({
          assetId: assetId === state.assetId ? null : assetId,
          isDuplicate
        });
      }

    default:
      {
        return state;
      }
  }
}

export default combineReducers({
  showRenameFileConfirm,
  showRenameFolderConfirm,
  currentRenameAsset
});